import { takeEvery, put } from 'redux-saga/effects'
import { VEHICLE_FLEET_SIZE_RECEIVED } from 'actions/truck'
import { GET_FLEET_INFORMATION } from 'actions/fleet'

export function* onFleetSizeReceived(action) {
  // The fleet API can return two shapes:
  //   1. Real API: action.data is an array of vehicle objects (each with
  //      serialNumber, isLeadSerial, customerName, etc.)
  //   2. Mock API (fleet1/fleet2): action.data is { fleet: string, vehicles: [] }
  // Legacy: action.vehicles was set directly by the old thunk shape.
  const rawData = action.data
  const vehicles = Array.isArray(rawData)
    ? rawData
    : rawData?.vehicles ?? action.vehicles ?? []
  // Fleet name: extracted from top-level `fleet` (mock object shape) or
  // delegated to the reducer which reads customerName from the lead vehicle
  // (real API array shape). null signals the reducer to use its own fallback.
  const fleetName = Array.isArray(rawData) ? null : rawData?.fleet ?? null

  // Warn in development when the legacy fallback runs so the migration can be
  // confirmed complete and this fallback eventually removed.
  if (process.env.NODE_ENV !== 'production' && action.vehicles !== undefined) {
    // eslint-disable-next-line no-console
    console.warn(
      '[fleetSizeReceived] Legacy action shape detected — action.vehicles set directly:',
      action.type
    )
  }

  yield put({ type: GET_FLEET_INFORMATION, vehicles, fleetName })
}

export default function* watchFleetSizeReceived() {
  yield takeEvery(VEHICLE_FLEET_SIZE_RECEIVED, onFleetSizeReceived)
}
